var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.526 5.5C5.95936 5.5 5.5 5.95936 5.5 6.526V17.474C5.5 18.0406 5.95936 18.5 6.526 18.5H17.474C18.0406 18.5 18.5 18.0406 18.5 17.474V6.526C18.5 5.95936 18.0406 5.5 17.474 5.5H6.526ZM4.5 6.526C4.5 5.40707 5.40707 4.5 6.526 4.5H17.474C18.5929 4.5 19.5 5.40707 19.5 6.526V17.474C19.5 18.5929 18.5929 19.5 17.474 19.5H6.526C5.40707 19.5 4.5 18.5929 4.5 17.474V6.526Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 4.5C8.77614 4.5 9 4.72386 9 5V19C9 19.2761 8.77614 19.5 8.5 19.5C8.22386 19.5 8 19.2761 8 19V5C8 4.72386 8.22386 4.5 8.5 4.5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 4.5C15.7761 4.5 16 4.72386 16 5V19C16 19.2761 15.7761 19.5 15.5 19.5C15.2239 19.5 15 19.2761 15 19V5C15 4.72386 15.2239 4.5 15.5 4.5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12C4.5 11.7239 4.72386 11.5 5 11.5H19C19.2761 11.5 19.5 11.7239 19.5 12C19.5 12.2761 19.2761 12.5 19 12.5H5C4.72386 12.5 4.5 12.2761 4.5 12Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 8.5C4.5 8.22386 4.72386 8 5 8H8.5C8.77614 8 9 8.22386 9 8.5C9 8.77614 8.77614 9 8.5 9H5C4.72386 9 4.5 8.77614 4.5 8.5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 15.5C4.5 15.2239 4.72386 15 5 15H8.5C8.77614 15 9 15.2239 9 15.5C9 15.7761 8.77614 16 8.5 16H5C4.72386 16 4.5 15.7761 4.5 15.5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15.5C15 15.2239 15.2239 15 15.5 15H19C19.2761 15 19.5 15.2239 19.5 15.5C19.5 15.7761 19.2761 16 19 16H15.5C15.2239 16 15 15.7761 15 15.5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.5C15 8.22386 15.2239 8 15.5 8H19C19.2761 8 19.5 8.22386 19.5 8.5C19.5 8.77614 19.2761 9 19 9H15.5C15.2239 9 15 8.77614 15 8.5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.9e32951198cbb27de63677b3cf1274f2.svg";
export { ForwardRef as ReactComponent };